import {BaseTerms} from "../../infrastructure/models/base-terms";

export class NewsWidgetTerms extends BaseTerms {
  WEB_ARTICLE_MINUTES_AGO = "# Minutes Ago";
  WEB_ARTICLE_HOURS_AGO = "# Hours Ago";
  WEB_ARTICLE_DAYS_AGO = "# Days Ago";
  WEB_ARTICLE_YESTERDAY = "Yesterday";
  SEE_ALL_ARTICLES_ALL_SCORE = "See all";
}
